import * as React from 'react';
import { Provider } from 'react-redux';
import {
  i18nReducer,
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';

import { FhqDesignTool } from './fhq-design-tool';
import { createStore } from '@common/utils/redux';
import { fhqDesignToolEN } from './translations/en';
import { fhqDesignToolES } from './translations/es';
import { fhqDesignToolJA } from './translations/ja';
import { combineReducers } from 'redux';
import { mountReactNode } from '@common/utils/react';

export const initFhqDesignTool = function (componentId: string, locale: string) {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
  
    syncTranslationWithStore(store);
  
    const translation = {
      en: fhqDesignToolEN,
      ja: fhqDesignToolES,
      es: fhqDesignToolJA,
    };
  
    if (!translation[locale as keyof typeof translation]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
    
    mountReactNode(
      <Provider store={store}>
        <FhqDesignTool /> 
      </Provider>,
      document.getElementById(componentId)!
    );
  } catch (err) {
    console.error(err);
  }
};
